// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import { useNavigate } from "react-router-dom";

import { useAuth } from "../../contexts/auth";
import { useIntercom } from "../../contexts/intercom";

export const useIntercomService = ({ category, isCategory }) => {
  const intercom = useIntercom();
  const navigate = useNavigate();
  const {
    userState: { currentUser, patientData },
  } = useAuth();

  return () =>
    isCategory
      ? navigate(`/services/${category}`)
      : intercom.updateUser({ currentUser, patient: patientData });
};
